<template>
  <div class="page-not-found">
    来错地方了? <br>
    404 NOT FOUND
  </div>
</template>

<script>
 export default {
   name: 'PageNotFound'
 }
</script>

<style lang="scss">
  .page-not-found {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cccccc;

    line-height: 2em;
    letter-spacing: 1px;
  }
</style>
